import { render, staticRenderFns } from "./PolymorphismDetail.vue?vue&type=template&id=9fbda67c&scoped=true"
import script from "./PolymorphismDetail.vue?vue&type=script&lang=js"
export * from "./PolymorphismDetail.vue?vue&type=script&lang=js"
import style0 from "./PolymorphismDetail.vue?vue&type=style&index=0&id=9fbda67c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbda67c",
  null
  
)

export default component.exports